import { createContext } from 'react';

interface AbsenceApplicationContextValue {
  onOpen: () => void;
  onOpenList: () => void;
  onOpenDetail: (applicationId: number) => void;
}

export const AbsenceApplicationContext =
  createContext<AbsenceApplicationContextValue | null>(null);
